import { LocalService } from './../services/storage/localService';
import { SessionStorageService } from './../services/storage/sessionStorage.service';
import { Component, Injector, OnInit } from "@angular/core";
import { LoginService } from "../services/login/login.service";
import { HttpErrorResponse } from "@angular/common/http";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { environment } from '../../environments/environment';
import { SecurityService } from '../services/security/security.service';
import { MessagesStatus, MessagesTitles } from '../models/messages';
import { Subject } from "rxjs";
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { EmpresasService } from 'app/services/empresas/empresas.service';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  providers: [MessagesTitles, MessagesStatus]
})
export class LoginComponent implements OnInit {
  TOKEN: string;
  loading: boolean = false;
  data: any;
  form: FormGroup;
  sessionActiva: boolean;
  ipAddress: any;
  IP: any;
  repAccesos: any;
  idRolUser: any;
  RutaDefault: any;
  comboProveedor: any;
  comboAdquirente: any;
  comboCliente: any;
  comboAvales: any;
  comboFactores: any;
  dataPermiso: any = [];
  repPermisos: any = [];
  user: any;
  RechazoDiazMinimo: any = "RECHAZO_FACTORING_PLAZO_MINIMO_EXPRESADO_EN_DIAS";
  ParametroRechazoMin: any;
  RechazoDiazMaximo: any = "RECHAZO_FACTORING_PLAZO_MAXIMO_EXPRESADO_EN_DIAS";
  ParametroRechazoMax: any;
  AdelantoMinimo: any = "PORCENTAJE_DESEMBOLSO_MINIMO";
  ParametroAdelantoMinimo: number;
  AdelantoMaximo: any = "PORCENTAJE_DESEMBOLSO_MAXIMO";
  ParametroAdelantoMaximo: number;
  AdelandoDefault: any = "PORCENTAJE_DESEMBOLSO_DEFAULT";
  ParametroAdelandoDefault: number;
  TasaMinimo: any = "CALCULO_TASA_TASA_MINIMA";
  ParametroTasaMinimo: number;
  TasaMinimoComercial: any = "CALCULO_TASA_TASA_MINIMA_COMERCIAL";
  ParametroTasaMinimoComercial: number;
  
  TipoCambioComercial: any = "TIPO_CAMBIO_COMERCIAL";
  ParametroTipoCambioComercial: number;
  TasaMaximo: any = "CALCULO_TASA_TASA_MAXIMA";
  ParametroTasaMaximo: number;
  IGVPorcentaje: any = "FACTOR_DE_IGV";
  ParametroIGVPorcentaje: number;
  Codigo: any = "LOGO_EMPRESA";
  ColorSec: any = "COLOR_SECUNDARIO";
  ColorPrim: any = "COLOR_PRIMARIO";
  ParametrosList: any;
  ParametrosList2: any;
  ParametroColor: any;
  ParametroColor2: any;
  bgImageUrl: string = "";
  color: string = "";
  color2: string = "";

  loginService: LoginService;
  securityService: SecurityService;
  empresasService: EmpresasService;
  riesgosService: RiesgoService;
  sessionStorageService: SessionStorageService;
  localService: LocalService;

  constructor(
    private injector: Injector,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus
  ) {
    this.loginService = this.injector.get<LoginService>(LoginService); 
    this.securityService = this.injector.get<SecurityService>(SecurityService);
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.riesgosService = this.injector.get<RiesgoService>(RiesgoService);
    this.sessionStorageService = this.injector.get<SessionStorageService>(SessionStorageService);
    this.localService = this.injector.get<LocalService>(LocalService);

    sessionStorage.clear();
    this.loginService.reloadPermiso = false;
    this.generarNumeroRandom(1000, 9999);

    this.loginService.getIP().subscribe(
      data => {
        this.ipAddress = data;
        sessionStorage.setItem('PUBLIC-IP', JSON.stringify(this.ipAddress));
      });

    this.form = new FormGroup({
      Usuario: new FormControl("", [Validators.required]),
      Password: new FormControl("", [Validators.required]),
      Ruc: new FormControl("10000000090", [Validators.required]),      
      NombreProyecto: new FormControl('WorkingCapital', []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl("10.10.100.100", []),
      Canal: new FormControl('W', [])
    });
  }

  ngOnInit() {
    this.proveedores.asObservable().subscribe(data => {
      this.comboProveedor = data;
      sessionStorage.setItem('lstProvCbo', JSON.stringify(this.comboProveedor));
    });
    this.adquirentes.asObservable().subscribe(data => {
      this.comboAdquirente = data;
      sessionStorage.setItem('lstAdqCbo', JSON.stringify(this.comboAdquirente));
    });
    this.clientes.asObservable().subscribe(data => {
      this.comboCliente = data;
      sessionStorage.setItem('lstCliCbo', JSON.stringify(this.comboCliente));
    });
    this.avales.asObservable().subscribe(data => {
      this.comboAvales = data;
      sessionStorage.setItem('lstavlCbo', JSON.stringify(this.comboAvales));
    });
    this.factores.asObservable().subscribe(data => {
      this.comboFactores = data;
      sessionStorage.setItem('lstFctCbo', JSON.stringify(this.comboFactores));
    });

    this.IP = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));
  }

  setStorageidEmpresa(value: string): void {
    this.sessionStorageService.setStorageItem({
      key: '1cefada07eb9',
      value,
      storageArea: "sessionStorage"
    });
  }

  guardarCambios() {
    this.loginService.uploadImage = false;
    this.loginService.clickGuard = true;
    this.loading = true;

    this.loginService.validarUsuario(this.form.value).subscribe(
      resp => {
        this.data = resp;

        if (!this.data.id_user) {
          this.loading = false;
          Swal.fire({
            title: "ERROR",
            text: "USUARIO NO ASOCIADO A ESTA EMPRESA",
            type: "error",
            allowOutsideClick: false
          });
        } else {
          sessionStorage.setItem('UserActive', JSON.stringify(resp));
          this.idRolUser = this.data.id_roles;
          this.RutaDefault = this.data.Ruta;
          this.ObtenerProveedoresCombo();
          this.ObtenerAdquirentesCombo();
          this.ObtenerClientesCombo();
          this.ObtenerAvalesCombo();
          this.ObtenerFactoresCombo();
          this.obtenerParametros(this.data.id_empresa);

          if (this.idRolUser == 1) {
            sessionStorage.setItem('UserRol', JSON.stringify(this.idRolUser));
          }
        }

        if (this.data.Imagen == null || this.data.Imagen == '') {
          sessionStorage.setItem('Foto', JSON.stringify('1bEnmr_VFVsx3mSu82fzdAOCB0oBKSiQE'));
        } else {
          let imagen = this.data.Imagen;
          let image = imagen.slice(imagen.lastIndexOf('=') + 1);
          sessionStorage.setItem('Foto', JSON.stringify(image));
        }
        let fecha = new Date();

        sessionStorage.setItem('sessionTime', fecha.getHours().toString() + "-" + fecha.getMinutes());

        this.encriptarTOKEN(environment.secret_key);

        this.localService.setJsonValue('prueba', this.data.id_empresa);
        this.setStorageidEmpresa(this.data.id_empresa + this.localService.getJsonValue('numeroRandom'));
        this.listadoEmpresasRiesgo();
      },
      () => {
        this.loading = false;
        Swal.fire({
          title: "Error",
          text: "Usuario o Contraseña Incorrectos",
          type: "error",
          allowOutsideClick: true
        });
      }
    );
  }

  obtenerParametros(id_empresa) {
    this.securityService.ObtenerParametros(id_empresa)
      .subscribe(res => {

        this.ParametrosList = res;
        this.ParametroColor = res;
        this.ParametroColor2 = res;
        this.ParametrosList2 = this.ParametrosList.filter(cta => cta.Codigo == this.Codigo);
        this.ParametroColor = this.ParametroColor.filter(cta2 => cta2.Codigo == this.ColorSec);
        this.ParametroColor2 = this.ParametroColor2.filter(cta3 => cta3.Codigo == this.ColorPrim);

        if (this.ParametrosList2[0].Valor.lenght != 0 || this.ParametroColor[0].Valor.lenght != 0 || this.ParametroColor2[0].Valor.lenght != 0) {
          this.bgImageUrl = this.ParametrosList2[0].Valor
          this.color = this.ParametroColor[0].Valor
          this.color2 = this.ParametroColor2[0].Valor
          sessionStorage.setItem('color', this.color);
          sessionStorage.setItem('color2', this.color2);
          document.documentElement.style.setProperty('--innova-primary', this.color2);
          document.documentElement.style.setProperty('--innova-default', this.color);
        }
        this.ParametroRechazoMin = this.ParametrosList.filter(pa => pa.Codigo == this.RechazoDiazMinimo);
        this.ParametroRechazoMax = this.ParametrosList.filter(pa => pa.Codigo == this.RechazoDiazMaximo);
        this.ParametroAdelantoMinimo = this.ParametrosList.filter(pa => pa.Codigo == this.AdelantoMinimo);
        this.ParametroAdelantoMaximo = this.ParametrosList.filter(pa => pa.Codigo == this.AdelantoMaximo);
        this.ParametroAdelandoDefault = this.ParametrosList.filter(pa => pa.Codigo == this.AdelandoDefault);
        this.ParametroTasaMinimo = this.ParametrosList.filter(pa => pa.Codigo == this.TasaMinimo);
        this.ParametroTasaMinimoComercial = this.ParametrosList.filter(pa => pa.Codigo == this.TasaMinimoComercial);
        this.ParametroTasaMaximo = this.ParametrosList.filter(pa => pa.Codigo == this.TasaMaximo);
        this.ParametroIGVPorcentaje = this.ParametrosList.filter(pa => pa.Codigo == this.IGVPorcentaje);
        this.ParametroTipoCambioComercial = this.ParametrosList.filter(pa => pa.Codigo == this.TipoCambioComercial);
        console.log('tipo cambio',this.ParametroTipoCambioComercial);
        this.localService.setJsonValue('ParametroRechazoMin', this.ParametroRechazoMin[0].Valor);
        this.localService.setJsonValue('ParametroRechazoMax', (this.ParametroRechazoMax[0].Valor));
        this.localService.setJsonValue('ParametroAdelantoMinimo', Number(this.ParametroAdelantoMinimo[0].Valor));
        this.localService.setJsonValue('ParametroAdelantoMaximo', Number(this.ParametroAdelantoMaximo[0].Valor));
        this.localService.setJsonValue('ParametroAdelandoDefault', Number(this.ParametroAdelandoDefault[0].Valor));
        this.localService.setJsonValue('ParametroTasaMinimo', Number(this.ParametroTasaMinimo[0].Valor));
        this.localService.setJsonValue('ParametroTasaMinimoComercial', Number(this.ParametroTasaMinimoComercial[0].Valor));
        this.localService.setJsonValue('ParametroTasaMaximo', Number(this.ParametroTasaMaximo[0].Valor));
        this.localService.setJsonValue('ParametroIGVPorcentaje', Number(this.ParametroIGVPorcentaje[0].Valor));
        this.localService.setJsonValue('ParametroTipoCambioComercial', Number(this.ParametroTipoCambioComercial[0].Valor));
        
      });
  }

  encriptarTOKEN(palabra: string) {
    const par = "U8WITLR2EMQVdI0bqQRjkKZaTrxxYq";
    const impar = "LyJDZGaw9Iwl7Sr1ZK4J";
    let p1 = `${par}ñ${impar}ñ${par}ñ${impar}ñ${palabra}ñ${impar}ñ${par}ñ${impar}ñ${par}ñ${impar}ñ${par}ñ${impar}ñ${palabra}ñ${impar}ñ${par}ñ${impar}ñ${par}`;
    sessionStorage.setItem('Kn48Nki8is9dhan54648asm78f6s3JDF56L4Ndf2SDdas55', p1.trim());
  }

  listadoEmpresasRiesgo() {
    this.riesgosService.FiltrosEmpresaRiesgo().subscribe(
      res => {
        let empresas: any;
        empresas = res['message'];
        sessionStorage.setItem('lstTopCbo', JSON.stringify(empresas));
      }
    )
  }

  ObtenerPermisosPorRol(id_roles: any) {
    this.securityService.ObtenerPermisosPorRol(id_roles)
      .subscribe(resp => {
        this.dataPermiso = resp;
        for (const iterator of this.dataPermiso) {
          iterator.submenu = [];
        }
        this.loginService.dataPermiso = this.dataPermiso;
        this.router.navigate([this.RutaDefault]);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA PERMISOS. NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false
        });
      });
  }

  private proveedores = new Subject<any>();
  ObtenerProveedoresCombo() {
    this.empresasService.obtenerProveedores().subscribe(res => {
      this.proveedores.next(res);
    });
  }

  private adquirentes = new Subject<any>();
  ObtenerAdquirentesCombo() {
    this.empresasService.obtenerAdquirente().subscribe(res => {
      this.adquirentes.next(res);
    });
  }

  private clientes = new Subject<any>();
  ObtenerClientesCombo() {
    this.empresasService.obtenerEmpresa().subscribe(res => {
      this.clientes.next(res);
      this.ObtenerPermisosPorRol(this.idRolUser);
    });
  }

  private avales = new Subject<any>();
  ObtenerAvalesCombo() {
    this.empresasService.obtenerAvalJuridico().subscribe(res => {
      this.avales.next(res);
    });
  }

  private factores = new Subject<any>();
  ObtenerFactoresCombo() {
    this.empresasService.obtenerFactores().subscribe(res => {
      this.factores.next(res);
    });
  }

  generarNumeroRandom(min: number, max: number) {
    this.localService.setJsonValue('numeroRandom', Math.floor(Math.random() * (max - min + 1) + min));
  }
}